// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"0b2b15e2","337":"0b2b15e2","454":"0b2b15e2","474":"0b2b15e2","903":"0b2b15e2"}[chunkId] + ".chunk.css";
};